export enum HomeNavigationKey {
	CREATE_NODE = 'creation',
	SEARCH = 'search',
	PROFILE = 'profile',
	CHAT_AI = 'chat',
	INTEGRATIONS = 'integrations',
	DASHBOARD = 'dashboard',
	TAXONOMIES = 'taxonomies',
	CATEGORIES = 'categories',
	PROPERTIES = 'properties',
	RELATIONSHIPS = 'relationships',
}
